module.exports = "/assets/data/0d1e26ad0312e31988af88749953c60c-WD23.data.json";